export default "<img src=\"caption-img\" :src=\"captionImgSrc\" :width=\"gifWidth\" />";